"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var cart_1 = require("../../utils/cart");
var hooks_1 = require("preact/hooks");
var CartContext_1 = require("./CartContext");
var ga_1 = require("../../utils/ga");
var hydrogen_react_1 = require("@shopify/hydrogen-react");
var Parser_1 = require("../Parser");
var UpgradeToThreeBottleSub = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var prod = _a.prod;
    if (!prod) {
        return (0, preact_1.h)(preact_1.Fragment, null);
    }
    var _j = (0, hooks_1.useContext)(CartContext_1.default), cart = _j.cart, renderCart = _j.renderCart;
    var replacedItem = cart.items.find(function (cartItem) { var _a; return cartItem.handle === ((_a = prod.replace) === null || _a === void 0 ? void 0 : _a.value); });
    if (window.sessionStorage.getItem('uro_vp_cart_upsell_test') === 'true' &&
        prod.title === 'URO Vaginal Probiotic Capsules - 3 Bottle Subscription' &&
        cart.items.some(function (cartItem) { return cartItem.variant_title === 'URO Vaginal Probiotic Capsule - 3 Pack Bundle'; })) {
        replacedItem = cart.items.find(function (cartItem) { return cartItem.variant_title === 'URO Vaginal Probiotic Capsule - 3 Pack Bundle'; });
    }
    var isSubscription = (0, cart_1.isSubscriptionItem)(prod);
    var productTitle = prod.title;
    var discountPercent = 10;
    if (productTitle.includes('FLO') ||
        productTitle.includes('MENO') ||
        (productTitle.includes('RETRO') && !productTitle.includes('Acne'))) {
        discountPercent = 15;
    }
    // ab test upsell title
    var unit = 'bottle';
    var bundleText = '';
    if (productTitle === 'URO Intimate Deodorant - 3 Month Subscription') {
        unit = 'tube';
    }
    if (productTitle === 'PREGGO Female & Male Conception Support Bundle - Quarterly Subscription') {
        bundleText = 'bundle';
    }
    var productTitleTest = window.isCartUpsellTest
        ? "Unlock extra savings with a 3-".concat(unit, " ").concat(bundleText, " subscription")
        : productTitle;
    // ab test upsell description
    var units = 'bottles';
    var additionalText = '';
    if (productTitle === 'URO Intimate Deodorant - 3 Month Subscription') {
        units = 'tubes';
    }
    if (productTitle === 'PREGGO Female & Male Conception Support Bundle - Quarterly Subscription') {
        additionalText = 'of each product';
    }
    var upsellDescriptionTest = "3 ".concat(units, " ").concat(additionalText, " deliver every 3 months");
    var upgradeToThreeCountUpsell = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!replacedItem) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, cart_1.updateCart)(event, replacedItem)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, (0, cart_1.addItem)(event.target)];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [4 /*yield*/, (0, cart_1.getCartData)()];
                case 5:
                    _a.sent();
                    return [4 /*yield*/, renderCart()];
                case 6:
                    _a.sent();
                    (0, ga_1.sendEventAddToCart)(prod, prod.variants.nodes[0], ga_1.GaMethodValue.cartUpsell);
                    return [2 /*return*/];
            }
        });
    }); };
    return ((0, preact_1.h)("div", { class: "cart-section__you-may-also-like-item" },
        (0, preact_1.h)("img", { class: "cart-section__you-may-also-like-item-image", src: (_b = prod.featuredImage) === null || _b === void 0 ? void 0 : _b.src }),
        (0, preact_1.h)("div", { class: "cart-section__you-may-also-like-item-info" },
            (0, preact_1.h)("div", { class: "cart-section__you-may-also-like-item-info-product" },
                ((_c = prod.upsellStatus) === null || _c === void 0 ? void 0 : _c.value) !== 'new' && ((0, preact_1.h)("div", { class: "cart-section__you-may-also-like-item-badge" },
                    "Save an additional ",
                    discountPercent,
                    "%")),
                (0, preact_1.h)("div", null,
                    (0, preact_1.h)("h4", { class: "cart-section__you-may-also-like-item-header" }, productTitleTest),
                    (0, preact_1.h)("p", { class: "cart-section__you-may-also-like-item-body" }, window.isCartUpsellTest
                        ? "".concat(upsellDescriptionTest)
                        : "".concat(productTitle.includes('RETRO - Glowing Skin')
                            ? '1 bottle delivered every month & save $5 per shipment'
                            : "3 ".concat(productTitle ===
                                'PREGGO Female & Male Conception Support Bundle - Quarterly Subscription'
                                ? 'female & male bundles'
                                : 'bottles', " delivered every 3 months, with an extra ").concat(discountPercent, "% off\n              each ").concat(productTitle ===
                                'PREGGO Female & Male Conception Support Bundle - Quarterly Subscription'
                                ? 'bundle'
                                : 'bottle'))))),
            (0, preact_1.h)("div", { class: "cart-section__you-may-also-like-item-price-cta" },
                !productTitle.includes('3 Bottle') &&
                    !productTitle.includes('3 Month Subscription') &&
                    !productTitle.includes('Quarterly') ? ((0, preact_1.h)("div", { class: "cart-section__you-may-also-like-item-price" },
                    (0, preact_1.h)("span", { class: "cart-section__you-may-also-like-item-price--strikethrough" }, isSubscription
                        ? Math.ceil(Number((_d = prod.variants.nodes[0].compareAtPrice) === null || _d === void 0 ? void 0 : _d.amount) / 3)
                        : (0, hydrogen_react_1.useMoney)({
                            amount: (Number((_e = prod.variants.nodes[0].compareAtPrice) === null || _e === void 0 ? void 0 : _e.amount) / 3).toFixed(2),
                            currencyCode: 'USD',
                        }).withoutTrailingZeros),
                    isSubscription && '/mo')) : ((0, preact_1.h)("div", null, !productTitle.includes('RETRO - Glowing Skin') && ((0, preact_1.h)("p", { class: "cart-section__you-may-also-like-item-guarantee" }, window.isCartUpsellTest
                    ? (0, Parser_1.parse)('90-Day Money-[br]Back Guarantee')
                    : (0, Parser_1.parse)('Exclusive 90-Day[br]Guarantee'))))),
                (0, preact_1.h)("div", null,
                    (0, preact_1.h)("form", { method: "POST", action: "/cart/add", class: "trigger--cart trigger--replace", "data-replace-item": replacedItem === null || replacedItem === void 0 ? void 0 : replacedItem.id, onSubmit: function (event) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, upgradeToThreeCountUpsell(event)];
                                case 1: return [2 /*return*/, _a.sent()];
                            }
                        }); }); } },
                        (0, preact_1.h)("input", { type: "hidden", name: "quantity", value: "1" }),
                        (0, preact_1.h)("input", { type: "hidden", name: "id", value: Number((_f = prod.variants.nodes[0]) === null || _f === void 0 ? void 0 : _f.id.split('/')[4]) }),
                        prod.sellingPlanGroups.nodes.length ? ((0, preact_1.h)("input", { type: "hidden", name: "selling_plan", value: Number((_h = (_g = prod.sellingPlanGroups.nodes[0]) === null || _g === void 0 ? void 0 : _g.sellingPlans.nodes[0]) === null || _h === void 0 ? void 0 : _h.id.split('/')[4]) })) : ((0, preact_1.h)(preact_1.Fragment, null)),
                        (0, preact_1.h)("button", { type: "submit", class: "cart-section__you-may-also-like-item-cta" }, "Apply Offer")))))));
};
exports.default = UpgradeToThreeBottleSub;
